import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import './product-list-common.js';

const childrenSlider = document.getElementById('js-children-slider');
if (childrenSlider) {
  new Swiper(childrenSlider, {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 8,
    grabCursor: true,
    navigation: {
      nextEl: childrenSlider.querySelector('.swiper-button-next'),
      prevEl: childrenSlider.querySelector('.swiper-button-prev'),
      addIcons: false,
    },
  });
}
